import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Badge } from '../ui/badge';
import { caseStudies } from '../../data/mock';

export const CaseStudiesSection = () => {
  return (
    <section id="case-studies" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#f26522] font-semibold text-sm tracking-wider uppercase">
            Case Studies
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-[#1e3a5f] leading-tight">
            Success Stories That Inspire
          </h2>
          <p className="mt-4 text-gray-600">
            Real results from our partnerships with businesses across industries.
          </p>
        </div>

        {/* Case Studies Grid */}
        <div className="grid lg:grid-cols-3 gap-8">
          {caseStudies.map((study) => (
            <div
              key={study.id}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#f26522]/30 hover:shadow-xl transition-all duration-300"
            >
              {/* Header */}
              <div className="p-6 bg-[#1e3a5f]">
                <Badge className="bg-[#f26522] text-white border-0 mb-3">
                  {study.industry}
                </Badge>
                <h3 className="text-xl font-semibold text-white">
                  {study.title}
                </h3>
              </div>

              {/* Content */}
              <div className="p-6 space-y-4">
                <div>
                  <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                    Challenge
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {study.challenge}
                  </p>
                </div>

                <div>
                  <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
                    Solution
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {study.solution}
                  </p>
                </div>

                {/* Technologies */}
                <div className="flex flex-wrap gap-2">
                  {study.technologies.map((tech, i) => (
                    <span
                      key={i}
                      className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                <div className="pt-4 border-t border-gray-100">
                  <h4 className="text-sm font-semibold text-[#f26522] uppercase tracking-wider mb-2">
                    Outcome
                  </h4>
                  <p className="text-[#1e3a5f] font-medium">
                    {study.outcome}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center text-[#f26522] font-medium hover:text-[#d95a1b] transition-colors"
          >
            Request More Case Studies
            <ArrowRight className="ml-2 w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
